export default __webpack_public_path__ + "static/media/n.3dcf6f8f.mp4";